// Bible book names in English and Spanish
export const bookTranslations = {
  // Old Testament
  'Genesis': { en: 'Genesis', es: 'Génesis' },
  'Exodus': { en: 'Exodus', es: 'Éxodo' },
  'Leviticus': { en: 'Leviticus', es: 'Levítico' },
  'Numbers': { en: 'Numbers', es: 'Números' },
  'Deuteronomy': { en: 'Deuteronomy', es: 'Deuteronomio' },
  'Joshua': { en: 'Joshua', es: 'Josué' },
  'Judges': { en: 'Judges', es: 'Jueces' },
  'Ruth': { en: 'Ruth', es: 'Rut' },
  '1 Samuel': { en: '1 Samuel', es: '1 Samuel' },
  '2 Samuel': { en: '2 Samuel', es: '2 Samuel' },
  '1 Kings': { en: '1 Kings', es: '1 Reyes' },
  '2 Kings': { en: '2 Kings', es: '2 Reyes' },
  '1 Chronicles': { en: '1 Chronicles', es: '1 Crónicas' },
  '2 Chronicles': { en: '2 Chronicles', es: '2 Crónicas' },
  'Ezra': { en: 'Ezra', es: 'Esdras' },
  'Nehemiah': { en: 'Nehemiah', es: 'Nehemías' },
  'Esther': { en: 'Esther', es: 'Ester' },
  'Job': { en: 'Job', es: 'Job' },
  'Psalms': { en: 'Psalms', es: 'Salmos' },
  'Psalm': { en: 'Psalm', es: 'Salmos' }, // Alias
  'Proverbs': { en: 'Proverbs', es: 'Proverbios' },
  'Ecclesiastes': { en: 'Ecclesiastes', es: 'Eclesiastés' },
  'Song of Solomon': { en: 'Song of Solomon', es: 'Cantares' },
  'Isaiah': { en: 'Isaiah', es: 'Isaías' },
  'Jeremiah': { en: 'Jeremiah', es: 'Jeremías' },
  'Lamentations': { en: 'Lamentations', es: 'Lamentaciones' },
  'Ezekiel': { en: 'Ezekiel', es: 'Ezequiel' },
  'Daniel': { en: 'Daniel', es: 'Daniel' },
  'Hosea': { en: 'Hosea', es: 'Oseas' },
  'Joel': { en: 'Joel', es: 'Joel' },
  'Amos': { en: 'Amos', es: 'Amós' },
  'Obadiah': { en: 'Obadiah', es: 'Abdías' },
  'Jonah': { en: 'Jonah', es: 'Jonás' },
  'Micah': { en: 'Micah', es: 'Miqueas' },
  'Nahum': { en: 'Nahum', es: 'Nahúm' },
  'Habakkuk': { en: 'Habakkuk', es: 'Habacuc' },
  'Zephaniah': { en: 'Zephaniah', es: 'Sofonías' },
  'Haggai': { en: 'Haggai', es: 'Hageo' },
  'Zechariah': { en: 'Zechariah', es: 'Zacarías' },
  'Malachi': { en: 'Malachi', es: 'Malaquías' },
  // New Testament
  'Matthew': { en: 'Matthew', es: 'Mateo' },
  'Mark': { en: 'Mark', es: 'Marcos' },
  'Luke': { en: 'Luke', es: 'Lucas' },
  'John': { en: 'John', es: 'Juan' },
  'Acts': { en: 'Acts', es: 'Hechos' },
  'Romans': { en: 'Romans', es: 'Romanos' },
  '1 Corinthians': { en: '1 Corinthians', es: '1 Corintios' },
  '2 Corinthians': { en: '2 Corinthians', es: '2 Corintios' },
  'Galatians': { en: 'Galatians', es: 'Gálatas' },
  'Ephesians': { en: 'Ephesians', es: 'Efesios' },
  'Philippians': { en: 'Philippians', es: 'Filipenses' },
  'Colossians': { en: 'Colossians', es: 'Colosenses' },
  '1 Thessalonians': { en: '1 Thessalonians', es: '1 Tesalonicenses' },
  '2 Thessalonians': { en: '2 Thessalonians', es: '2 Tesalonicenses' },
  '1 Timothy': { en: '1 Timothy', es: '1 Timoteo' },
  '2 Timothy': { en: '2 Timothy', es: '2 Timoteo' },
  'Titus': { en: 'Titus', es: 'Tito' },
  'Philemon': { en: 'Philemon', es: 'Filemón' },
  'Hebrews': { en: 'Hebrews', es: 'Hebreos' },
  'James': { en: 'James', es: 'Santiago' },
  '1 Peter': { en: '1 Peter', es: '1 Pedro' },
  '2 Peter': { en: '2 Peter', es: '2 Pedro' },
  '1 John': { en: '1 John', es: '1 Juan' },
  '2 John': { en: '2 John', es: '2 Juan' },
  '3 John': { en: '3 John', es: '3 Juan' },
  'Jude': { en: 'Jude', es: 'Judas' },
  'Revelation': { en: 'Revelation', es: 'Apocalipsis' },
  // Deuterocanonical (Catholic Bibles only)
  'Tobit': { en: 'Tobit', es: 'Tobías' },
  'Judith': { en: 'Judith', es: 'Judit' },
  'Wisdom': { en: 'Wisdom', es: 'Sabiduría' },
  'Sirach': { en: 'Sirach', es: 'Eclesiástico' },
  'Baruch': { en: 'Baruch', es: 'Baruc' },
  '1 Maccabees': { en: '1 Maccabees', es: '1 Macabeos' },
  '2 Maccabees': { en: '2 Maccabees', es: '2 Macabeos' },
};

// Helper function to get book name in the appropriate language.
// Accepts any number of "signals" (a translation id like 'RVR1960' and/or an
// app language code like 'es'); the name is localized to Spanish if ANY signal
// indicates Spanish. This lets book names follow either the selected Bible
// translation OR the app UI language.
const SPANISH_TRANSLATIONS = ['rvr1960', 'rvg', 'rvr1909', 'rv1909', 'onbv', 'ess', 'pdpt', 'blm', 'vbl', 'rvr1995', 'nvi', 'dhh', 'pdt', 'lbla', 'bso', 'rva', 'ntv', 'tla', 'rv1865', 'ta', 'bll', 'jun', 'rv1602', 'rv1569'];

const signalIsSpanish = (s) => {
  if (!s) return false;
  const c = String(s).replace("+Strong's", "").toLowerCase();
  return c === 'es' || c === 'spanish' || c === 'español' || SPANISH_TRANSLATIONS.includes(c);
};

export const getBookName = (bookEnglish, ...signals) => {
  const isSpanish = signals.some(signalIsSpanish);
  const book = bookTranslations[bookEnglish];
  if (!book) return bookEnglish;
  return isSpanish ? book.es : book.en;
};

// Check if translation is Spanish
export const isSpanishTranslation = (translation) => signalIsSpanish(translation);

// "1 John 4:8" → "1 Juan 4:8" when Spanish; unknown books pass through unchanged.
export const localizeReference = (ref, spanish) => {
  const m = spanish && typeof ref === 'string' ? ref.match(/^(.+?)\s+(\d+(?:[-–]\d+)?(?::\d+(?:[-–]\d+)?)?)$/) : null;
  return m && bookTranslations[m[1]] ? `${bookTranslations[m[1]].es} ${m[2]}` : ref;
};
